export function builtMessageXML(message) {
    return new DOMParser()
        .parseFromString(String.fromCharCode.apply(null, new Uint16Array(message)), 'application/xml');
}
export function getChallenge(doc) {
    var el = doc.getElementsByTagName('Challenge')[0];
    try {
        return atob(el.childNodes[0].nodeValue);
    }
    catch (e) {
        throw 'cannot parse <Challenge> from init message';
    }
}
export function builtHeadersFromXML(doc) {
    var headers = {};
    var headerNames = doc.getElementsByTagName('name');
    var headerValues = doc.getElementsByTagName('value');
    if (headerNames.length !== headerValues.length) {
        throw 'header names and values are not match';
    }
    for (var i = 0; i < headerNames.length; i++) {
        headers[headerNames[i].childNodes[0].nodeValue] = headerValues[i].childNodes[0].nodeValue;
    }
    return headers;
}
